export function isClickOnWaypointHelper(features: any[]): boolean {
  if (features.length > 0) {
    let feature = features[0]
    if (feature.source.includes('waypoint')) {
      return true
    }
  }
  return  false
}
